/**
 * Twitch viewer panel.
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import PanelPage from '../views/PanelPage.vue';

Vue.use(VueRouter);

const routes = [
	{
		path: '*/',
		name: 'panel',
		component: PanelPage,
		props: { isComponentView: true },
	},
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
});

export default router;
